// API Keys and Model Configuration
// NOTE: OpenAI key is currently EXPIRED - get a new one from https://platform.openai.com/account/api-keys
export const API_KEYS = {
  OPENAI_API_KEY: "YOUR_NEW_OPENAI_KEY_HERE", // EXPIRED - needs replacement
  GEMINI_API_KEY: "AIzaSyD9pZLE8K9BdD93AzEebFUpdqefj8b7T54" // ✅ Valid
};

export const MODELS = {
  OPENAI_MODEL: "gpt-image-1",
  GEMINI_MODEL: "gemini-2.5-flash-image-preview"
};

export const API_ENDPOINTS = {
  OPENAI_GENERATE: "https://api.openai.com/v1/images/generations",
  GEMINI_GENERATE: "https://generativelanguage.googleapis.com/v1beta/models/gemini-2.5-flash-image-preview:generateContent"
};

// Image generation configuration
// When OpenAI key is valid: 2 OpenAI + 2 Gemini = 4 total
// When OpenAI key is invalid: 4 Gemini only
export const IMAGE_CONFIG = {
  DEFAULT_COUNT: 4,
  OPENAI_COUNT: 2,
  GEMINI_COUNT: 2,
  IMAGE_SIZE: "1024x1024",
  QUALITY: "hd",
  // Feature flag - set to false until OpenAI key is updated
  USE_OPENAI: false
};
